import { useCallback, useContext } from "react";

import { Clock } from "@magnetic/icons";
import { Select } from "@magnetic/select";
import { SelectOption } from "@magnetic/select/dist/types/types";
import { Text } from "@magnetic/text";
import { Toggle } from "@magnetic/toggle";

import { HFlex } from "src/components";
import { TimeZoneContext } from "src/core/timeZoneProvider";
import { TimeFormat } from "src/gen/schema/models/auth";
import { getUserTimeZone, UTC } from "src/utils/timeZone/timeZoneUtils";

import "./timeZoneSection.scss";

const localTimeZone = getUserTimeZone();
const timeZoneOptions: SelectOption[] =
  localTimeZone === UTC
    ? [
        {
          label: "UTC (Local)",
          value: UTC
        }
      ]
    : [
        {
          label: `Local ${localTimeZone}`,
          value: localTimeZone
        },
        {
          label: "UTC",
          value: UTC
        }
      ];

export const TimeZoneSection = () => {
  const { timeZone, hourFormat, changeTimeZone, changeTimeFormat } =
    useContext(TimeZoneContext);

  const handleTimeFormatChange = useCallback(() => {
    let updatedTimeFormat =
      hourFormat === TimeFormat.TIME_FORMAT_12HR
        ? TimeFormat.TIME_FORMAT_24HR
        : TimeFormat.TIME_FORMAT_12HR;
    if (timeZone === UTC) {
      updatedTimeFormat = TimeFormat.TIME_FORMAT_24HR;
    }
    changeTimeFormat(updatedTimeFormat);
  }, [changeTimeFormat, hourFormat, timeZone]);

  const handleTimeZoneChange = useCallback(
    (value: string) => {
      if (value === UTC) {
        changeTimeFormat(TimeFormat.TIME_FORMAT_24HR);
      }
      changeTimeZone(value);
    },
    [changeTimeFormat, changeTimeZone]
  );
  return (
    <div className="time-zone-format-section">
      <HFlex className="time-zone-section">
        <Clock weight="bold" size={24} className="clock-icon" />
        <Text weight="bold">Timezone</Text>
        <Select
          data-qa="timezone-select"
          placeholder={"Select timezone"}
          options={timeZoneOptions}
          value={timeZone}
          onChange={handleTimeZoneChange}
          size="sm"
          className="timezone-select"
          rootId="timezone-select"
        />
      </HFlex>
      <HFlex justify={"flex-end"} className="hour-cycle-toggle-section">
        <Text className="toggle-label">12hr</Text>
        <Toggle
          checked={
            hourFormat === TimeFormat.TIME_FORMAT_24HR || timeZone === UTC
          }
          onClick={handleTimeFormatChange}
          disabled={timeZone === UTC}
          data-qa="hour-cycle-toggle"
        />
        <Text className="toggle-label">24hr</Text>
      </HFlex>
    </div>
  );
};
